// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4":"b88f89f9","134":"53136113","292":"a9595839","344":"52102614","406":"d9b01b7f","593":"5faaab5b","623":"133a6d71","768":"72e624f4","981":"db277027"}[chunkId] + ".chunk.css";
};